import { render, staticRenderFns } from "./RegisterTeacherScheduleCard.vue?vue&type=template&id=57f9c67c&scoped=true&"
import script from "./RegisterTeacherScheduleCard.vue?vue&type=script&lang=js&"
export * from "./RegisterTeacherScheduleCard.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTeacherScheduleCard.vue?vue&type=style&index=0&id=57f9c67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f9c67c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
